import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PinAuthService } from '../services/auth/pin-auth.service';

/**
 * Гуард для страницы ввода пин-кода.
 * - Если пин не установлен - перенаправляет на настройку
 * - Если пользователь уже авторизован - перенаправляет на главную
 */
export const pinAuthAccessGuard: CanActivateFn = async () => {
  const pinAuthService = inject(PinAuthService);
  const router = inject(Router);

  const isPinSet = await pinAuthService.isPinSet();

  if (!isPinSet) {
    return router.createUrlTree(['/pin-setup']);
  }

  if (pinAuthService.isAuthenticated()) {
    return router.createUrlTree(['/mining']);
  }

  return true;
};
